<template>
<div style="height:100%">
    <div class="message" id="messagepanel">
        <div v-for="item in session.messages" :key="item.id">
            <p class="time">
                <span>{{ item.date }}</span>
            </p>
            <div class="main" :class="{ self: item.self }">
                <img class="avatar" width="30" height="30" :src="item.self ? user.img : session.user.img" />
                <div class="text" style="white-space: pre-line;">{{item.content}}</div>
            </div>
        </div>
        <div class="main" v-if="is_sending">
            <img class="avatar" width="30" height="30" :src="botimg" />
            <div class="text">I am thinking, please waiting a minute...</div>
        </div>
    </div>
    <div class="send-text">
        <textarea placeholder="按 Ctrl + Enter 发送" v-model="content" @keyup="onKeyup" :disabled="is_sending"></textarea>
    </div>
</div>
</template>

<script>
import userimg from "./images/1.jpg"
import botimg from "./images/chatbot.png"
import { message } from 'ant-design-vue';
export default{
    name: "MessagePanel",
    data() {
        return {
            botimg: botimg,
            user: {
                name: 'User',
                img: userimg
            },
            session: {
                id: 1,
                user: {
                    name: '示例介绍',
                    img: botimg
                },
                messages: [
                    {
                        content: 'Hello, Welcome to AIDA, Can I Help You?',
                        date: new Date()
                    }
                ]
            },
            content: "",
            is_sending: false,
        }
    },
    methods: {
        onKeyup(e){
            if (e.ctrlKey && e.keyCode === 13 && this.content.length) {
                //this.sendMessage(this.content);
                this.session.messages.push({
                    content: this.content,
                    date: new Date(),
                    self: true,
                })
                this.content = 'I am thinking, please waiting a minute...';
                this.is_sending = true;
                this.send_chat();
            }
        },
        send_chat(){
            var url = "http://47.251.13.252:10000/v1/chat/completions";
            // url = "http://127.0.0.1:9000/v1/chat/completions";
            var data = {
                "model": "gpt-3.5-turbo",
                "messages": []
            };
            /*var url = "http://47.88.16.101:10000/v1/chat/web/reply";
            data = {
                "question": "模仿李白写一篇描述春天桃花的诗",
                "email": "",
                "password": "",
                "puid": ""
            };*/
            for(let i=1;i<this.session.messages.length;i++){
                let temp = {
                    role: this.session.messages[i].self? "user":"assistant",
                    content: this.session.messages[i].content
                }
                data.messages.push(temp);
                this.scrollPanel();
            }
            this.http({
                url: url,
                data: data,
                success: this.refesh_chat_messages
                });
        },
        refesh_chat_messages(data){
            console.log(data);
            if(!data.code){
                if(data.data && data.data.choices && data.data.choices.length>0){
                    var temp = {
                        content: data.data.choices[0].message.content.replace("OpenAI", "AIDA Assistant").replace("ChatGPT", "AIDA Assistant")
                    };
                    this.session.messages.push(temp);
                }
            }else{
                message.error(data.message);
            }
            this.scrollPanel();
            this.content = "";
            this.is_sending = false;
        },

        // refesh_chat_messages(data){
        //     console.log(data);
        //     if(!data.code){
        //         if(data.data && data.data.choices && data.data.choices.length>0){
        //             var temp = {
        //                 content: data.data.choices[0].message.content
        //             };
        //             this.session.messages.push(temp);
        //         }
        //     }else{
        //         message.error(data.message);
        //     }
        //     this.scrollPanel();
        //     this.content = "";
        //     this.is_sending = false;
        // },

        scrollPanel(){
            setTimeout(function(){
                var el = document.getElementById("messagepanel");
                el.scrollTop = el.scrollHeight;
            }, 50);
        },
        http ({ url, data, success }) {
            const xhr = new XMLHttpRequest()
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if ((xhr.status >= 200 || xhr.status < 300) || xhr.status === 304) {
                        success && success(JSON.parse(xhr.response))
                    } else {
                        console.error(xhr)
                    }
                }
            }
            xhr.open("POST", url);
            xhr.setRequestHeader("Authorization", "Bearer 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");
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify(data))
        }
    },
    directives: {
        // 发送消息后滚动到底部
    }
}
</script>


<style lang="less" scoped>
.message {
    padding: 10px 15px;
    overflow-y: scroll;
    height: ~'calc(100% - 180px)';
    div {
        margin-bottom: 15px;
    }
    .time {
        margin: 7px 0;
        text-align: center;

        > span {
            display: inline-block;
            padding: 0 18px;
            font-size: 12px;
            color: #fff;
            border-radius: 2px;
            background-color: #dcdcdc;
        }
    }
    .avatar {
        float: left;
        margin: 0 10px 0 0;
        border-radius: 3px;
    }
    .text {
        display: inline-block;
        position: relative;
        padding: 0 10px;
        max-width: ~'calc(100% - 40px)';
        min-height: 30px;
        line-height: 2.5;
        font-size: 12px;
        text-align: left;
        word-break: break-all;
        background-color: #fafafa;
        border-radius: 4px;

        &:before {
            content: " ";
            position: absolute;
            top: 9px;
            right: 100%;
            border: 6px solid transparent;
            border-right-color: #fafafa;
        }
    }

    .self {
        text-align: right;

        .avatar {
            float: right;
            margin: 0 0 0 10px;
        }
        .text {
            background-color: #b2e281;

            &:before {
                right: inherit;
                left: 100%;
                border-right-color: transparent;
                border-left-color: #b2e281;
            }
        }
    }
}
.send-text {
    height: 160px;
    border-top: solid 1px #ddd;

    textarea {
        padding: 10px;
        height: 100%;
        width: 100%;
        border: none;
        outline: none;
        font-family: "Micrsofot Yahei";
        resize: none;
    }
}
</style>